import {Injectable} from '@angular/core';
import * as xmlParser from 'fast-xml-parser';
import {X2jOptionsOptional} from 'fast-xml-parser';

@Injectable(
  {providedIn: 'root'}
)
export class XmlParserService {

  private prser = xmlParser;

  get parser(): any {
    if (xmlParser) {
      return this.prser;
    }
  }

  parse(text: string, options: X2jOptionsOptional): any {

    return this.prser.parse(text, options);
  }
}
